import { render, staticRenderFns } from "./color-defaultValue-editor.vue?vue&type=template&id=6d0d4c98&scoped=true"
import script from "./color-defaultValue-editor.vue?vue&type=script&lang=js"
export * from "./color-defaultValue-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0d4c98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d0d4c98')) {
      api.createRecord('6d0d4c98', component.options)
    } else {
      api.reload('6d0d4c98', component.options)
    }
    module.hot.accept("./color-defaultValue-editor.vue?vue&type=template&id=6d0d4c98&scoped=true", function () {
      api.rerender('6d0d4c98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-color/color-defaultValue-editor.vue"
export default component.exports